/* Modus & Mood: Conversions API relay for the custom pixel's events (6 Oct 2026).
   The custom pixel (docs/custom-pixel-mm-wishlist.js) sends AddToWishlist, CouponApplyClick, CouponApplied and
   MoodQuizComplete from Shopify's sandbox, where Meta's _fbp and _fbc cookies are out of reach. This script sits
   in front of Shopify.analytics.publish: for those four events it stamps a shared event id on the data (the pixel
   uses it as eventID) and posts the same event, with the cookies and the hashed identity from mm-identity.js, to
   the Netlify service, which forwards it to Meta's Conversions API. Meta deduplicates on the id.
   Sent only when marketing cookies are allowed, like the pixel itself. */
(function () {
  var API = 'https://mm-wishlist-sync.netlify.app/api/capi-event';
  var MAP = { wishlist_add: 'AddToWishlist', coupon_apply_click: 'CouponApplyClick', coupon_result: 'CouponApplied', mm_quiz_complete: 'MoodQuizComplete' };
  function uuid() {
    return 'mm-' + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
    });
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.marketingAllowed === 'function') return api.marketingAllowed() !== false;
    } catch (e) {}
    return true;
  }
  function payload(name, d) {
    var meta = MAP[name];
    if (!meta) return null;
    if (name === 'coupon_result' && !d.applied) return null;
    var data = {};
    if (name === 'wishlist_add') {
      data = { content_ids: [String(d.variant_id || d.product_id || d.handle || '')], content_name: d.title, value: d.price, currency: d.currency || 'INR' };
    } else if (name === 'coupon_apply_click') {
      data = { coupon: d.code, source: d.source, value: d.subtotal, currency: 'INR' };
    } else if (name === 'coupon_result') {
      data = { coupon: d.code, value: d.discount_after, currency: 'INR' };
    } else {
      data = { mood: d.mood, second: d.second, budget: d.budget, who: d.who, mode: d.mode };
    }
    var user = (window.MMIdentity && window.MMIdentity.get && window.MMIdentity.get()) || {};
    return {
      name: meta, id: d.mm_event_id, time: Math.floor(Date.now() / 1000), url: location.href, data: data,
      user: { em: user.em || '', ph: user.ph || '', external_id: user.eid || '' },
      fbp: cookie('_fbp'), fbc: cookie('_fbc')
    };
  }
  function send(name, d) {
    if (!allowed()) return;
    var body = payload(name, d);
    if (!body) return;
    try {
      fetch(API, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body), keepalive: true, credentials: 'omit' }).catch(function () {});
    } catch (e) {}
  }
  function wrap() {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function' || a.__mmCapi) return !!(a && a.__mmCapi);
    var orig = a.publish;
    a.__mmCapi = true;
    a.publish = function (name, data) {
      if (MAP[name] && data && typeof data === 'object') {
        if (!data.mm_event_id) data.mm_event_id = uuid();
        send(name, data);
      }
      return orig.apply(this, arguments);
    };
    return true;
  }
  if (!wrap()) {
    var tries = 0;
    var timer = setInterval(function () { if (wrap() || ++tries > 40) clearInterval(timer); }, 250);
  }
})();
